import { render, staticRenderFns } from "./VPSUserSuspendedPage.vue?vue&type=template&id=08bc7994&scoped=true"
import script from "./VPSUserSuspendedPage.vue?vue&type=script&lang=js"
export * from "./VPSUserSuspendedPage.vue?vue&type=script&lang=js"
import style0 from "./VPSUserSuspendedPage.vue?vue&type=style&index=0&id=08bc7994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bc7994",
  null
  
)

export default component.exports